import { gql } from '@apollo/client'

export default gql(`
    mutation updatePerson($name: String!, $project: String, $image: ID, $id: ID!) {
        updatePerson(
            input: {
                name: $name
                image: $image
            },
            id: $id,
            project: $project
        ) {
            id
            name
            image{
                id
                name
                fileName
                aspectRatio {
                    aspectRatio
                    ratio
                    title          
                    resolutions {
                      url
                    }
                }
                settings {
                    aspectRatio
                    outputFormat
                    fileName
                    x1
                    y1
                    x2
                    y2          
                }
            }
            usedCount
        }
    }`
)
